class ProductBuyButtons extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.button_container = this.querySelector(".product-buy-buttons--primary"), this.button_text = this.querySelector(".product-buy-buttons--cta-text"), this.select_input = this.querySelector(".product-buy-buttons--select"), this.smart_button = this.querySelector(".product-buy-buttons--smart"), this.primary_button = this.querySelector(".product-buy-buttons--cta"), this.price_original = this.querySelector(".product-buy-buttons--price-original"), this.price_compare = this.querySelector(".product-buy-buttons--price-compare"), this.showComparePrice = true, this.addToCartListener(), this.updateViewListener(), this.subscriptionPriceListener(), this.initPriceToggle()
    }
    addToCartListener() {
        this.closest("form").on("submit", async t => {
            var e = this.querySelector("option[selected]")["dataset"],
                r = t.target.querySelector("[name=quantity]"),
                a = theme.utils.getQuantity(this.dataset.id, e, r.value);
            if ("drawer" !== theme.settings.cart_type && !1 !== a || (t.preventDefault(), t.stopPropagation()), a && (this.button_container.setAttribute("data-loading", !0), "drawer" === theme.settings.cart_type)) {
                var i = new FormData(t.target),
                    s = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: new URLSearchParams(i).toString()
                    };
                try {
                    await theme.cart.addItem(s, e.id), this.button_container.setAttribute("data-loading", !1)//, theme.drawer.open("right", "cart-drawer", this.primary_button)
                } catch (t) {
                    throw this.button_container.setAttribute("data-loading", !1), new Error(t)
                }
            }
        })
    }
    updateViewListener() {
        window.on(`theme:product:${this.dataset.id}:variantChanged`, ({
            detail: {
                variant: t
            }
        }) => {
            var e = this.select_input.querySelector("option[selected]");
            e && e.removeAttribute("selected"), t && t.available ? (this.selectVariant(t.id), this.updateView(!0, !0), this.updatePrices(t)) : t && !t.available ? (this.selectVariant(t.id), this.updateView(!1, !0), this.updatePrices(t)) : this.updateView(!1, !1)
        })
    }
    selectVariant(t) {
        var e = this.select_input.querySelector(`option[value='${t}']`);
        e && e.setAttribute("selected", !0)
    }
    updateView(t, e) {
        t ? (this.primary_button.removeAttribute("disabled"), this.button_text.innerText = theme.translations.add_to_cart, this.smart_button && this.smart_button.setAttribute("aria-hidden", !1)) : (this.primary_button.setAttribute("disabled", !0), this.smart_button && this.smart_button.setAttribute("aria-hidden", !0), this.button_text.innerText = e ? theme.translations.out_of_stock : theme.translations.unavailable)
    }
    updatePrices(t) {
        if (t) {
            this.price_original && (this.price_original.innerHTML = theme.utils.formatMoney(t.price)), t.compare_at_price > t.price ? (this.price_compare && (this.price_compare.innerHTML = theme.utils.formatMoney(t.compare_at_price), this.price_compare.style.display = this.showComparePrice ? "inline-block" : "none")) : this.price_compare && (this.price_compare.style.display = "none")
        }
    }
    subscriptionPriceListener() {
        const t = this;
        // Listen to variant changes to update subscription prices
        window.on(`theme:product:${this.dataset.id}:variantChanged`, ({
            detail: {
                variant: variant
            }
        }) => {
            if (!variant) return;
            
            // Update button price based on selected subscription option
            const subscribeRadio = document.querySelector(".purchase-box.subscribe input[type='radio']:checked");
            if (subscribeRadio) {
                const subNew = subscribeRadio.closest(".purchase-box").querySelector(".sub-new");
                if (subNew && subNew.textContent && t.price_original) {
                    const priceText = subNew.textContent.trim();
                    if (priceText) {
                        t.price_original.innerHTML = priceText;
                    }
                }
            } else {
                // One-time purchase: use variant price directly
                if (t.price_original) {
                    t.price_original.innerHTML = theme.utils.formatMoney(variant.price);
                }
            }
        });
        
        // Also listen to subscription radio changes to update price immediately
        document.addEventListener('change', (e) => {
            if (e.target.matches('.purchase-box input[type="radio"]')) {
                const subscribeRadio = document.querySelector(".purchase-box.subscribe input[type='radio']:checked");
                if (subscribeRadio) {
                    const subNew = subscribeRadio.closest(".purchase-box").querySelector(".sub-new");
                    if (subNew && subNew.textContent && t.price_original) {
                        const priceText = subNew.textContent.trim();
                        if (priceText) {
                            t.price_original.innerHTML = priceText;
                        }
                    }
                } else {
                    const oneTimeRadio = document.querySelector(".purchase-box.js-one input[type='radio']:checked");
                    if (oneTimeRadio) {
                        const onePrice = oneTimeRadio.closest(".purchase-box").querySelector(".one-price");
                        if (onePrice && onePrice.textContent && t.price_original) {
                            const priceText = onePrice.textContent.trim();
                            if (priceText) {
                                t.price_original.innerHTML = priceText;
                            }
                        }
                    }
                }
            }
        });
    }
    initPriceToggle() {
        // Create a global toggle function that can be called from anywhere
        window.toggleComparePrice = (show) => {
            this.showComparePrice = show !== undefined ? show : !this.showComparePrice;
            this.updateComparePriceVisibility();
        };
        
        // Initialize compare price visibility based on current setting
        this.updateComparePriceVisibility();
    }
    updateComparePriceVisibility() {
        if (this.price_compare) {
            const hasComparePrice = this.price_compare.textContent.trim() !== '';
            this.price_compare.style.display = (this.showComparePrice && hasComparePrice) ? "inline-block" : "none";
        }
    }
}
const productBuyButtonsEl = customElements.get("product-buy-buttons-root");
productBuyButtonsEl || customElements.define("product-buy-buttons-root", ProductBuyButtons);